module.exports = __webpack_public_path__ + "img/26.9b8a5e2e.png";